import { render, staticRenderFns } from "./TrendSection.vue?vue&type=template&id=483a97dd&scoped=true&"
import script from "./TrendSection.vue?vue&type=script&lang=js&"
export * from "./TrendSection.vue?vue&type=script&lang=js&"
import style0 from "./TrendSection.vue?vue&type=style&index=0&id=483a97dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a97dd",
  null
  
)

export default component.exports